import { ListPaiement } from './../../../utils/interfaces/new/Facture';
import { Component, Inject, OnInit, OnDestroy,ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { FacturesList } from 'src/app/utils/interfaces/new/Facture';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { RecettesService } from 'src/app/services/recettes/recettes.service';
import { AddPaiementRequest, ListPaiementsResponse } from 'src/app/utils/interfaces/new/recettes-paiements.models';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PatientService } from 'src/app/services/patient/patient.service';

export interface PaiementDialogData {
  idFacture: string;
  total: number;
  dejaPaye: number;
  patientId?: string;
  patientName?: string;
  numFacture?: string;
  num?: string;
  dateFacture?: string;
  data?: FacturesList;
  montantPatient?:number;
}

type ModePaiement = 'ESPECES' | 'CB' | 'CHEQUE' | 'VIREMENT' | 'AMO' | 'AMC' | 'OFFERT';

@Component({
  selector: 'app-add-paiement-facture',
  templateUrl: './add-paiement-facture.component.html',
  styleUrls: ['./add-paiement-facture.component.scss']
})

export class AddPaiementFactureComponent implements OnInit, OnDestroy {
  public modes: { value: ModePaiement; label: string; icon: string }[] = [
    { value: 'ESPECES', label: 'ESP', icon: 'payments' },
    { value: 'CB', label: 'CB', icon: 'credit_card' },
    { value: 'CHEQUE', label: 'CHQ', icon: 'receipt_long' },
    { value: 'VIREMENT', label: 'VIR', icon: 'sync_alt' },
    { value: 'AMO', label: 'AMO', icon: 'sync_alt' },
    { value: 'AMC', label: 'AMC', icon: 'sync_alt' },
    { value: 'OFFERT', label: 'Offert', icon: 'more_horiz' },
  ];

  // Chips “raccourcis”
  public payeurSuggestions = ['AMO', 'AMC', 'EHPAD', 'Tuteur','Hôpital','Employeur','Médecine du travail'];
  public montantRapide = [];
  public dataPaiementDialog: PaiementDialogData | undefined;
  public today = new Date().toISOString().slice(0, 10);
  public paiementPatientSeul = false;
  public factureId: string = '';
  public meta?: ListPaiementsResponse['meta'] = {
    total: 0,
    paye: 0,
    restant: 0
  };
  public listPaiements: ListPaiementsResponse['items'] = [];
  public checkTiers = false;
  public payeurNom = '';

  public form = this.fb.group({
    mode: ['ESPECES' as ModePaiement, Validators.required],
    montant: [null as number | null, [Validators.required, Validators.min(0.01)]],
    datePaiement: [this.today, Validators.required],
    note: [''],
    regleParTiers: [false],                                 // coché par défaut
    payeurNom: [{ value: '', disabled: true }, [Validators.maxLength(255)]],
    numeroCheque: [''],
    banqueCheque: ['']
  });
  public sub!: Subscription;
  public replacePatient = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PaiementDialogData,
    private fb: FormBuilder,
    private ref: MatDialogRef<AddPaiementFactureComponent>,
    private snackbar: SnackbarService,
    private recettes: RecettesService,
    private modalsrv: ModalService,
    private viewContainerRef: ViewContainerRef,
    private _patientSrv: PatientService,
  ) {}

  async ngOnInit() {
    if(this.data as PaiementDialogData === undefined){
      this.ref.close(false);
      this.snackbar.openSnackBarError("Aucune donnée de facturation trouvée.")
      return;
    }
    this.dataPaiementDialog = this.data;
    this.factureId = this.dataPaiementDialog.idFacture;

    if(!this.dataPaiementDialog.data){
      //on viens de la creation FSE
      // le total est celui du patient pas le total complet.
      this.paiementPatientSeul = true;
      this.modes = [
        { value: 'ESPECES', label: 'ESP', icon: 'payments' },
        { value: 'CB', label: 'CB', icon: 'credit_card' },
        { value: 'CHEQUE', label: 'CHQ', icon: 'receipt_long' },
        { value: 'VIREMENT', label: 'VIR', icon: 'sync_alt' },
        // { value: 'AMO', label: 'AMO', icon: 'sync_alt' },
        // { value: 'AMC', label: 'AMC', icon: 'sync_alt' },
        { value: 'OFFERT', label: 'Offert', icon: 'more_horiz' },
      ];
      this.montantRapide.unshift(
          { value: this.dataPaiementDialog.total, label: 'Patient :' }
      );
    }

    if(this.dataPaiementDialog.data){
      const factureData = this.dataPaiementDialog.data;
      if(factureData.montantAMC && factureData.montantAMC > 0){
        this.montantRapide.unshift(
          { value: factureData.montantAMC, label: 'AMC :' }
        );
      }
      if(factureData.montantAMO && factureData.montantAMO > 0){
        this.montantRapide.unshift(
          { value: factureData.montantAMO, label: 'AMO :' }
        );
      }
      if(factureData.montantPatient && factureData.montantPatient > 0){
        this.montantRapide.unshift(
          { value: factureData.montantPatient, label: 'Patient :' }
        );
      }
    }

    await this.refresh();

    // Activer/Désactiver le champ payeurNom et (dé)poser les validateurs
    this.syncPayeurNomValidators();
    this.sub = this.form.get('regleParTiers')!.valueChanges
      .subscribe(() => this.syncPayeurNomValidators());
  }

  ngOnDestroy(): void {
    this.sub && this.sub.unsubscribe();
  }

  private async refresh() {
    try {
      const res = await this.recettes.listPaiements(this.factureId,this.paiementPatientSeul);
      this.listPaiements = res.items;
      this.meta = res.meta;
      this.resetForm();
    } catch (err: any) {
      this.snackbar.openSnackBar(err?.error?.message || 'Erreur chargement paiements');
    }
  }

  /** Préremplit le champ montant avec le restant si vide (ou toujours si force=true) */
  private setDefaultMontantIfEmpty(force = false) {
    const ctrl = this.form.get('montant');
    const isEmpty = ctrl?.value == null || ctrl?.value === '';
    if (force || isEmpty) {
      const val = Math.max(0, (this.meta?.restant || 0));
      this.form.patchValue({ montant: val || null }, { emitEvent: false });
    }
  }

  private syncPayeurNomValidators(): void {
    const isPatient = !!this.form.get('regleParTiers')!.value;
    const payeurCtrl = this.form.get('payeurNom')!;

    if (!isPatient) {
      // Si réglé par le patient → on n’a PAS besoin du champ payeur
      payeurCtrl.reset('');
      payeurCtrl.disable({ emitEvent: false });
      payeurCtrl.clearValidators();
    } else {
      // Si NON réglé par le patient → payeurNom devient obligatoire
      payeurCtrl.enable({ emitEvent: false });
      payeurCtrl.setValidators([Validators.required, Validators.maxLength(255)]);
    }
    payeurCtrl.updateValueAndValidity({ emitEvent: false });
  }

  public applyPayeur(value: string): void {
    // Remplit directement le champ payeur
    this.form.get('payeurNom')!.setValue(value);
    this.form.get('payeurNom')!.markAsDirty();
  }

  public applyMontantRapide(mr: any): void {
    // Remplit directement le champ montant
    let mode = 'ESPECES';
    switch (mr.label) {
      case 'AMO :':
        mode = 'AMO';
        break;
      case 'AMC :':
        mode = 'AMC';
        break;
      case 'Patient :':
        mode = 'ESPECES';
        break;
      default:
        break;
    }
    this.form.get('mode')?.setValue(mode);
    this.form.get('montant')!.setValue(mr.value);
    this.form.get('montant')!.markAsDirty();

  }

  async onAddPaiement() {
    if (this.form.invalid) return;
    const v = this.form.value;
    const montant = Number(v.montant);
    if (montant <= 0) {
      this.snackbar.openSnackBarWarning(`Le montant saisi (${montant}€ ) est invalide`);
      return;
    }
    if (montant > this.meta.restant) {
      this.snackbar.openSnackBarWarning(`Le montant saisi (${montant}€ ) dépasse le montant restant (${this.meta.restant}€)`);
      return;
    }

    const isTiers = !!v.regleParTiers;
    const payeurNom = isTiers ? (v.payeurNom?.trim() || undefined) : (this.dataPaiementDialog.patientName || undefined) ;
    const payeurId = isTiers ? undefined : (this.dataPaiementDialog.patientId || undefined);
    if(v.mode !== 'CHEQUE'){
      this.form.get('numeroCheque')?.setValue('');
      this.form.get('banqueCheque')?.setValue('');
    } else {
      if((!v.numeroCheque || v.numeroCheque.trim() === '') || (!v.banqueCheque || v.banqueCheque.trim() === '')){
        this.snackbar.openSnackBar(`Pour un paiement par chèque, le numéro et la banque du chèque sont recommandés.`);
        // return;
      }
    }
    // const idem = (window.crypto?.randomUUID?.() ?? uuidv4()); // génère ta clé
    try {
      const payload: AddPaiementRequest = {
        paiement: {
          datePaiement: this.toYMD(v.datePaiement!),
          montant,
          type: v.mode!,
          commentaire: v.note || undefined,
          payeurId,
          payeurNom,
          numeroCheque: v.numeroCheque || undefined,
          banqueCheque: v.banqueCheque || undefined,
        },
        montantRegle: montant,
        knownRestant: this.paiementPatientSeul ? undefined : this.meta?.restant,
        duPatient: this.paiementPatientSeul
      };
      const res = await this.recettes.addPaiement(this.factureId, payload);
      this.meta = res.meta;
      // si ton backend renvoie un PaiementResponse unique :
      this.listPaiements = [...this.listPaiements, res.paiement];
      this.resetForm();
    } catch (err: any) {
      this.snackbar.openSnackBarError(err?.error?.message || 'Erreur ajout paiement');
    }
  }

  async onDeletePaiement(row: any) {
    try {
      //TODO au besoin prevoir l'infos de restant patient seul en cas de suppression sur saisie paiement retour FSE.
      const paiementId = row.paiementId;
      const meta = await this.recettes.deletePaiement(this.factureId, paiementId);
      this.meta = meta;
      this.listPaiements = this.listPaiements.filter(p => p.paiementId !== paiementId);
      this.resetForm();
    } catch (err: any) {
      this.snackbar.openSnackBarError(err?.error?.message || 'Erreur suppression paiement');
    }
  }

  private resetForm() {
    this.setDefaultMontantIfEmpty(true);
    this.form.reset({
      mode: this.modes[0].value,
      datePaiement: this.today,
      note: '',
      montant: this.meta.restant,
      regleParTiers: false,
      payeurNom: ''
    });
  }

  close() {
    const retourMeta = {
      paiements: this.listPaiements,
      meta: this.meta,
      factureId: this.factureId,
      reload: this.replacePatient,
    }
    this.ref.close(retourMeta);
  }

  private toYMD(d: any): string | null {
    if (!d) return null;

    // Déjà une string → normalise vite fait
    if (typeof d === 'string') {
      // YYYY-MM-DD (garde les 10 premiers)
      const iso = d.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
      // DD/MM/YYYY → YYYY-MM-DD
      const fr = d.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (fr) return `${fr[3]}-${fr[2]}-${fr[1]}`;
      // sinon on fait confiance
      return d;
    }

    // Moment (ou dayjs-like) : possède format()/isValid()
    if (d && typeof d.format === 'function' && typeof d.isValid === 'function') {
      return d.isValid() ? d.format('YYYY-MM-DD') : null;
    }

    // Timestamp
    if (typeof d === 'number') {
      const dt = new Date(d);
      if (!isNaN(dt.getTime())) return ymd(dt);
      return null;
    }

    // Date native
    if (d instanceof Date) {
      if (!isNaN(d.getTime())) return ymd(d);
      return null;
    }

    // Dernier essai : constructible en Date
    const parsed = new Date(d);
    return isNaN(parsed.getTime()) ? null : ymd(parsed);

    function ymd(dt: Date): string {
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
    }
  }

  async changePatient() {
    const modalRef = this.modalsrv.openModalSearchPatient(this.viewContainerRef);
    const idPatient = await new Promise<string | null>((resolve) => {
      const sub = modalRef.instance.closeEmitter.subscribe((id?: string) => {
        resolve(id ?? null);       // résout la promesse quand la modale se ferme
        sub.unsubscribe();
        this.modalsrv.close(modalRef);
      });
    });

    if (idPatient) {
      const patient = await this._patientSrv.findOnePatientInfos(idPatient);
      if (patient) {
        this.dataPaiementDialog.patientId = patient.id;
        this.dataPaiementDialog.patientName = patient.nomNaissance + ' ' + patient.prenom + ' (' + patient.dateNaissance + ')';
        const success = await this.recettes.reassignSingleFactureAndPatientPayments(this.factureId, idPatient);
        this.refresh();
        this.replacePatient = true;
      }

    }

  }

}
